import React from 'react';
import { useSearchParams } from 'react-router-dom';
import ProductPublishEditor from '@/shein-platform/modules/products/ProductPublishEditor';

/** 发布产品（支持 ?draftId= / ?productTemplateId= / ?fromProductTemplate=<token>） */
export default function ProductPublishWizardPage() {
  const [params] = useSearchParams();
  const draftId = params.get('draftId') || '';
  const productTemplateId = params.get('productTemplateId') || '';
  const fromProductTemplate = params.get('fromProductTemplate') || '';
  const referenceShopId = params.get('shopId') || '';
  return (
    <ProductPublishEditor
      mode="create"
      draftId={draftId}
      productTemplateId={productTemplateId}
      fromProductTemplate={fromProductTemplate}
      referenceShopId={referenceShopId}
    />
  );
}
